import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { CheckPicker, Col, FlexboxGrid, FormGroup, HelpBlock, Icon, Tooltip, Whisper } from 'rsuite';

import { changeAddProduct, changeCheckAllProduct, changeRemoveProduct, searchProdutos } from '../../../../../actions/actionsPainelGeral';

import { LoadingMenu } from '../../../../../components/LoadingSpinner';
import { FilterSelectAllExtraFooter } from './FilterSelectAllExtraFooter';
import MobileProductFilter from './MobileProductFilter';
import { ProductFilterMenuRender } from './ProductFilterMenuRender';
import { getModelPanel } from '../utils';
import { PRODUCT_FILTER_LOCALE, PRODUCT_WARNING_NO_DATA, PRODUCT_WARNING_NO_DATA_TOOLTIP } from '../data';

export const ProductFilter = ({ usuario, onOpenProduto, onSearchProduto, onClickLoadMore }) => {
  const [checkAllProduto, setCheckAllProduto] = useState(false);
  const [indeterminateProduto, setIndeterminateProduto] = useState(false);

  const dispatch = useDispatch();

  const { produto } = useSelector(
    state => ({
      produto: state.painelGeralDataReducer.produto,
    }),
    shallowEqual,
  );

  const handleAddProduct = item => {
    dispatch(changeAddProduct(item));
    setCheckAllProduto(false);
  };

  const handleSelect = (value, item) => {
    const hasValue = produto.value.includes(item.value);
    if (hasValue) {
      dispatch(changeRemoveProduct(item.value));
    } else {
      handleAddProduct(item);
    }
  };

  const handleFilterProduto = inputValue => {
    onSearchProduto(inputValue);
    setCheckAllProduto(false);
  };

  const handleCleanProduct = () => {
    dispatch(changeCheckAllProduct([], []));
    handleFilterProduto();
  };

  const handleCheckAllProduto = (value, checked) => {
    let newCacheProduto;
    let newValueProduto;

    if (checked) {
      newCacheProduto = produto?.cache?.concat(produto?.lista?.filter(cache => produto.cache.findIndex(item => item.value === cache.value) === -1));
      newValueProduto = newCacheProduto.map(item => item.value);
    } else {
      newCacheProduto = produto?.cache?.filter(cacheItem => produto?.lista?.findIndex(item => cacheItem.label === item.label) === -1);
      newValueProduto = [];
    }

    dispatch(changeCheckAllProduct(newCacheProduto, newValueProduto));

    setIndeterminateProduto(false);
    setCheckAllProduto(checked);
  };

  const handleOnOpen = () => {
    onOpenProduto();
    const input = document.getElementsByClassName('rs-picker-search-bar-input')[0];
    input.focus();
  };

  const handleLoadMore = () => {
    setCheckAllProduto(false);
    onClickLoadMore();
  };

  useEffect(() => {
    dispatch(searchProdutos(getModelPanel({}, '', 'produto')));
  }, []);

  const PRODUCT_UNAVAILABLE = produto?.disabled?.length;
  const RENDER_BUTTON_DISABLED = produto?.lista?.length >= 1000;
  const TOOLTIP_PLACEMENT = window.innerWidth < 995 ? 'left' : 'right';

  return (
    <>
      <FlexboxGrid.Item componentClass={Col} xs={22} lgHidden mdHidden>
        <MobileProductFilter />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item componentClass={Col} lg={22} md={20} xsHidden smHidden>
        <FormGroup>
          <CheckPicker
            block
            id="product-filter-desktop"
            className="inf-picker"
            menuClassName="product-filter-menu"
            name="produtos"
            placeholder="Produto"
            maxHeight={200}
            disabledItemValues={produto.disabled}
            value={produto.value}
            data={produto.lista}
            filter={false}
            locale={PRODUCT_FILTER_LOCALE}
            onSelect={(value, item) => handleSelect(value, item, 'Produto')}
            onSearch={handleFilterProduto}
            onClean={handleCleanProduct}
            onOpen={handleOnOpen}
            renderMenuItem={(label, item) => <ProductFilterMenuRender label={label} item={item} usuario={usuario} />}
            renderExtraFooter={() => (
              <FilterSelectAllExtraFooter
                list={produto?.lista}
                indeterminate={indeterminateProduto}
                checked={checkAllProduto}
                buttonDisabled={RENDER_BUTTON_DISABLED}
                onChange={handleCheckAllProduto}
                onClick={handleLoadMore}
              />
            )}
            renderMenu={menu => (
              <span>
                <LoadingMenu area="panel-filter" />
                {menu}
              </span>
            )}
          />
          {PRODUCT_UNAVAILABLE ? (
            <HelpBlock className="warning-no-data" name="noDataFilterWarning">
              {PRODUCT_WARNING_NO_DATA}
            </HelpBlock>
          ) : null}
        </FormGroup>
      </FlexboxGrid.Item>
      <FlexboxGrid.Item componentClass={Col} lg={1} md={2} xs={2}>
        <Whisper
          placement={TOOLTIP_PLACEMENT}
          trigger="hover"
          speaker={
            <Tooltip>
              <p>{PRODUCT_WARNING_NO_DATA_TOOLTIP}</p>
            </Tooltip>
          }
        >
          <Icon className="tooltip-info" icon="info" />
        </Whisper>
      </FlexboxGrid.Item>
    </>
  );
};

export default ProductFilter;
